"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    query Query($myHomeAccountId: String!, $dealerNumber: String) {
        leadsubmitted(myHomeAccountId: $myHomeAccountId, dealerNumber: $dealerNumber)
    }
`;exports.getLeadSubmitted=e;
//# sourceMappingURL=queries.js.map
